import React from 'react';

const Stats: React.FC = () => {
  return (
    <section className="stats">
      <div className="container">
        <div className="stats-grid">
          <div className="stat-item">
            <h3 className="stat-number">150+</h3>
            <p className="stat-label">Destinations</p>
          </div>
          <div className="stat-item">
            <h3 className="stat-number">50k+</h3>
            <p className="stat-label">Happy Travelers</p>
          </div>
          <div className="stat-item">
            <h3 className="stat-number">98%</h3>
            <p className="stat-label">Satisfaction Rate</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats; 